<div class="flex flex-col gap-1 min-w-0">
  <h1
    *ngIf="displayTitle && pageTitle"
    class="text-lg font-semibold leading-snug text-foreground truncate m-0"
  >
    {{ pageTitle }}
  </h1>
  <p-breadcrumb
    *ngIf="items?.length"
    [model]="items"
    styleClass="hrm-breadcrumb-trail"
  ></p-breadcrumb>
</div>
